import { NECESSARY_COOKIES, ANALYTICS_COOKIES, FUNCTIONAL_COOKIES, MARKETING_COOKIES } from './sections';

export default {
  default: 'en',
  translations: {
    en: {
      consentModal: {
        title: 'We value your privacy',
        description:
          'We use cookies to enhance your browsing experience, serve personalized content, and to analyze our traffic. By clicking "Accept All", you consent to our use of cookies. <a href="https://any.run/cookie-policy" target="_blank">Cookie Policy</a> <br> {{revisionMessage}}',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Reject All',
        showPreferencesBtn: 'Customize',
        revisionMessage: "Hi, we've made some changes to our cookie policy since the last time you visited!"
      },
      preferencesModal: {
        title: 'Customize Consent Preferences',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Reject All',
        savePreferencesBtn: 'Save My Preferences',
        closeIconLabel: 'Close modal',
        sections: [
          {
            title: '',
            description:
              'We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below. For more information on how Google’s third-party cookies operate and handle your data, see: <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.'
          },
          { ...NECESSARY_COOKIES },
          { ...ANALYTICS_COOKIES },
          { ...FUNCTIONAL_COOKIES },
          { ...MARKETING_COOKIES }
        ]
      }
    },
    it: {
      consentModal: {
        title: 'We value your privacy',
        description:
          'We use cookies to enhance your browsing experience, serve personalized content, and to analyze our traffic. By clicking "Accept All", you consent to our use of cookies. <a href="https://any.run/cookie-policy" target="_blank">Cookie Policy</a> <br> {{revisionMessage}}',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Reject All',
        showPreferencesBtn: 'Customize',
        revisionMessage: "Hi, we've made some changes to our cookie policy since the last time you visited!"
      },
      preferencesModal: {
        title: 'Customize Consent Preferences',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Reject All',
        savePreferencesBtn: 'Save My Preferences',
        closeIconLabel: 'Close modal',
        sections: [
          {
            title: '',
            description:
              'We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below. For more information on how Google’s third-party cookies operate and handle your data, see: <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.'
          },
          { ...NECESSARY_COOKIES },
          { ...ANALYTICS_COOKIES },
          { ...FUNCTIONAL_COOKIES },
          { ...MARKETING_COOKIES }
        ]
      }
    },
    us: {
      consentModal: {
        title: 'We value your privacy',
        description:
          'We use cookies to enhance your browsing experience, serve personalized content, and to analyze our traffic. See detailed information about data collection and processing in our <a href="https://any.run/privacy.pdf" target="_blank">Privacy Policy</a>, more information about cookies in our <a href="https://any.run/cookie-policy" target="_blank">Cookie Policy</a> <br> {{revisionMessage}}',
        showPreferencesBtn: 'Customize',
        revisionMessage: "Hi, we've made some changes to our cookie policy since the last time you visited!"
      },
      preferencesModal: {
        title: 'Customize Consent Preferences',
        acceptAllBtn: 'Accept All',
        acceptNecessaryBtn: 'Reject All',
        savePreferencesBtn: 'Save My Preferences',
        closeIconLabel: 'Close modal',
        sections: [
          {
            title: '',
            description:
              'We use cookies to help you navigate efficiently and perform certain functions. You will find detailed information about all cookies under each consent category below. For more information on how Google’s third-party cookies operate and handle your data, see: <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.'
          },
          { ...NECESSARY_COOKIES },
          { ...ANALYTICS_COOKIES },
          { ...FUNCTIONAL_COOKIES },
          { ...MARKETING_COOKIES }
        ]
      }
    }
  }
};
